import { LoadState } from '@util/types'
import { createMemberhsipAPIClient } from '@api/BffAPIClientFactory'

const memberhsipAPIClient = createMemberhsipAPIClient()

function createState () {
  return {
    membership: {
      status: LoadState.None,
      response: {},
    },
  }
}

export default {
  namespaced: true,
  state: createState,
  mutations: {
    MEMBERSHIP_REQUEST (state) {
      state.membership.status = LoadState.Loading
    },
    MEMBERSHIP_RESPONSE (state) {
      state.membership.status = LoadState.Success
    },
    MEMBERSHIP_ERROR_RESPONSE (state, payload) {
      state.membership.status = LoadState.Error
      state.membership.response = payload
    },
  },
  actions: {
    fetchMembershipInfo ({ commit }) {
      commit('MEMBERSHIP_REQUEST')
      return new Promise((resolve, reject) => {
        memberhsipAPIClient
          .getMembershipInfo()
          .then((response) => {
            commit('MEMBERSHIP_RESPONSE')
            resolve(response.data)
          })
          .catch((error) => {
            commit('MEMBERSHIP_ERROR_RESPONSE', error.response)
            reject(error)
          })
      })
    },
  },
  getters: {
    hasValidMembership: state => state.membership.status === LoadState.Success,
  },
}

